import { SettingsContainer } from "../../../../components/molecules/settingsContainer";
import { SteambotEnroll } from "MVVM/Components/SteambotEnroll";

export const SteambotSettings = () => (
  <SettingsContainer
    title="Steam Bot"
    subtitle="Add the Allstar bot as a Steam friend. It picks up your CS2 matches the moment they end and messages you when they're ready, with your best highlights."
  >
    <SteambotEnroll />
  </SettingsContainer>
);
